// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.btn-primary.btn-outline {
  color: #fff;
}

img {
  max-width: 100%;
  height: auto;
}

.products-grid {
  overflow: hidden;
}

.products-grid .product-imitation {
  padding: 10px;
}
.products-grid .product-imitation img {
  width: 100%;
  height: auto;
  max-height: 340px;
  min-height: 340px;
  -webkit-object-fit: contain;
  -ms-object-fit: contain;
  -moz-object-fit: contain;
  object-fit: contain;
}

.category-title {
  font-size: 32px;
  font-family: "Museo-700" !important;
  color: #6d6e71 !important;
  margin: 0 0 20px;
}

::ng-deep.products-grid .product-box {
  height: 482px;
  min-height: 482px;
  padding-bottom: 12px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.products-grid .product-box {
    height: auto;
  }
}
::ng-deep.products-grid .product-desc {
  min-height: 125px;
  padding: 10px;
}
::ng-deep.products-grid .product-desc .text-righ {
  bottom: 0;
  left: 0;
  padding-left: 15px;
  padding-right: 0px;
  float: right;
}

.cart-icons {
  float: right;
  text-align: right;
  top: 37px;
  right: 30px;
}
.cart-icons .dropdown-back {
  width: 22px;
  display: inline-block;
  position: relative;
  color: #636363;
}
.cart-icons .basket-item-count {
  position: absolute;
  left: 0;
  top: -12px;
  right: 0;
}

.order-dropdown {
  width: 80%;
  display: inline-block;
}
.order-dropdown select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  width: 100%;
  display: inline-block;
  margin-right: 1em;
  margin-top: 5px;
  margin-bottom: 15px;
}

@media screen and (max-width: 480px) {
  .fullwidth-mob {
    width: 100%;
  }
}
.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader i {
  font-size: 8em !important;
}

.bottom-prod-btn input {
  width: 63px;
  height: 22px;
  border: 1px solid #676a6c;
  padding: 4px;
}
.bottom-prod-btn .pd-0 {
  padding: 0;
}
.bottom-prod-btn .col-sm-6 {
  padding-left: 0;
}

.product-name {
  min-height: 48px;
}
@media (max-width: 767px) {
  .product-name {
    min-height: unset;
  }
}

.product-top .row {
  margin: 0 -6px;
}
.product-top .row > div {
  padding: 0 6px;
}
.product-top + div {
  margin-top: 10px;
}
@media (max-width: 767px) {
  .product-top .col-md-4 {
    width: 50%;
    float: left;
  }
}
@media (max-width: 640px) {
  .product-top .col-md-4 {
    width: 100%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .container {
    width: 540px;
    max-width: 100%;
  }
}
nav.woocommerce-breadcrumb {
  position: relative;
  padding: 8px 0;
  font-family: "Museo-300";
  margin-top: 22px;
}
nav.woocommerce-breadcrumb::before {
  background: #f5f5f5 none repeat scroll 0 0;
  content: "";
  height: 100%;
  left: -270%;
  position: absolute;
  top: 0;
  width: 600%;
  z-index: -9;
  display: block;
}
nav.woocommerce-breadcrumb a {
  color: #767676;
}
@media screen and (max-width: 1200px) {
  nav.woocommerce-breadcrumb {
    margin-top: 0;
  }
}

.products-grid {
  padding-top: 0;
}

h1.page-title {
  font-family: "Museo-700";
  padding-bottom: 20px;
}

.efulfill-msg {
  padding: 15px 15px 15px 45px;
  background: #6D6E70;
  margin-bottom: 10px;
  position: relative;
  font-family: "Museo-300";
}
.efulfill-msg--alert {
  background: red;
}
.efulfill-msg--bg {
  background: #FF7F7F;
}
.efulfill-msg p {
  color: #fff;
  margin-bottom: 0;
  font-size: 16px;
  font-weight: bold;
}
@media screen and (max-width: 767px) {
  .efulfill-msg p {
    font-size: 12px;
  }
}
.efulfill-msg :before {
  content: "";
  width: 30px;
  height: 30px;
  background: url("https://foursightonline.com/wp-content/uploads/2020/05/notification.png") no-repeat;
  background-size: contain;
  position: absolute;
  top: 11px;
  left: 10px;
}
@media screen and (max-width: 767px) {
  .efulfill-msg {
    padding: 15px;
  }
}

.profile-content {
  clear: both;
  overflow: hidden;
  width: 100%;
  display: block;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd !important;
  border-radius: 4px;
  transition: border 0.2s ease-in-out;
  font-family: "Museo-300";
}
.profile-content h3 {
  font-size: 32px;
  font-family: "Museo-700";
  line-height: 38px;
  max-width: 422px;
}
.profile-content .flagstrap {
  position: relative;
}
.profile-content .flagstrap select {
  background-color: #F5F5F5;
  color: #000000;
  padding: 5px;
  width: 250px;
  border: none;
  font-size: 20px;
  appearance: button;
  outline: none;
}
.profile-content .assessment-image {
  float: left;
  padding-left: 10px;
  width: 24%;
}
@media screen and (max-width: 767px) {
  .profile-content .assessment-image {
    width: 100%;
  }
}
.profile-content .caption.profile-text-content {
  float: left;
  width: 76%;
  padding: 9px;
  color: #333;
  padding-top: 0 !important;
  padding-left: 24px;
}
@media screen and (max-width: 767px) {
  .profile-content .caption.profile-text-content {
    width: 100%;
    padding-left: 10px;
  }
}
.profile-content .caption.profile-text-content strong {
  font-size: 24px;
  color: #636363;
}
.profile-content .caption.profile-text-content p {
  font-size: 14px;
}
@media (min-width: 768px) {
  .profile-content .caption.profile-text-content .profile-text .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 1200px) {
  .profile-content .caption.profile-text-content .profile-text .col-md-6 {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.profile-content .caption.profile-text-content .profile-text .btn {
  font-size: 14px;
}
.profile-content .caption.profile-text-content .profile-text .btn-product {
  color: #fff;
  background-color: #7BBC43;
  border-color: #7BBC43;
}
.profile-content .caption.profile-text-content .profile-text .form-horizontal.language .form-group {
  margin: 0 0 20px 0;
}
.profile-content .caption.profile-text-content .profile-text .form-horizontal.language .form-group label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 14px;
}
.profile-content .caption.profile-text-content .profile-text .form-horizontal.language .form-group #flagstrap3 {
  width: inherit;
  margin: 0;
  display: inline-block;
  position: relative;
}
.profile-content .caption.profile-text-content .profile-text .form-horizontal.language .form-group select {
  color: #333;
  background-color: #fff;
  width: 200px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 31px;
  position: relative;
  font-size: 12px;
}
@media screen and (max-width: 767px) {
  .profile-content {
    text-align: center;
  }
}

.wrapper-top {
  margin-top: 50px;
}

.wrapper-content .cont {
  padding-inline: 15px;
  margin-inline: auto;
}
@media screen and (min-width: 768px) {
  .wrapper-content .cont {
    width: 750px;
  }
}
@media screen and (min-width: 992px) {
  .wrapper-content .cont {
    width: 970px;
  }
}
@media screen and (min-width: 1400px) {
  .wrapper-content .cont {
    width: 1350px;
  }
}
@media screen and (min-width: 1600px) {
  .wrapper-content .cont {
    width: 1570px;
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1850px) {
  .wrapper-content .cont {
    width: 1300px;
    padding-inline: 15px;
  }
}
@media screen and (max-width: 1440px) {
  .wrapper-content .cont {
    width: 100%;
  }
}
.wrapper-content .cont .profile-text {
  font-size: 17px;
  color: #000000;
  line-height: 1.6;
}
.wrapper-content .cont .profile-text .grp-ordr {
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 30px;
}
.wrapper-content .cont .profile-text--bdr {
  border-right: 2px solid #F5F5F5;
}
@media screen and (max-width: 991px) {
  .wrapper-content .cont .profile-text {
    width: 100%;
  }
}
@media screen and (max-width: 1199px) {
  .wrapper-content .cont .prdct {
    width: 33.3333%;
  }
}
@media screen and (max-width: 991px) {
  .wrapper-content .cont .prdct {
    width: 50%;
  }
}
@media screen and (max-width: 767px) {
  .wrapper-content .cont .prdct {
    width: 100%;
  }
}

hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eeeeee;
  box-sizing: content-box;
  height: 0;
}

.api-err {
  color: #676a6c;
  background-color: #fff;
  box-shadow: 0px 0px 6px #cccaca;
}
.api-err p {
  color: #676a6c;
  font-size: 14px;
}
.api-err h1 {
  font-family: "Museo-700";
}

::ng-deep.prod-hdr {
  font-size: 32px;
}
::ng-deep.prod-body span {
  font-family: "Museo-300";
  font-size: 12px;
}
::ng-deep.prod-body input {
  font-family: "Museo-300";
  font-size: 12px;
}
::ng-deep.prod-body .muso-700 {
  font-family: "Museo-700";
  color: #676a6c;
}
::ng-deep.prod-list li {
  font-size: 16px;
  font-family: "Museo-700";
  color: #676a6c;
}

.gap-10 {
  gap: 10px;
}

::ng-deep.hero-prod-buy {
  margin-top: -20px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-store-products/public-store-products.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACE,WAAA;AA6YF;;AA1YA;EACE,eAAA;EACA,YAAA;AA6YF;;AA1YA;EACE,gBAAA;AA6YF;;AAzYE;EACE,aAAA;AA4YJ;AA1YI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;AA4YN;;AAnYA;EACE,eAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;AAsYF;;AAlYE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;AAqYJ;AAnYI;EALF;IAMI,YAAA;EAsYJ;AACF;AAnYE;EACE,iBAAA;EACA,aAAA;AAqYJ;AAnYI;EAEE,SAAA;EAEA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAmYN;;AA9XA;EACE,YAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAiYF;AA/XE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAiYJ;AA9XE;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;AAgYJ;;AA5XA;EACE,UAAA;EACA,qBAAA;AA+XF;AA7XE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AA+XJ;;AA3XA;EACE;IACE,WAAA;EA8XF;AACF;AA3XA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA6XF;AA3XE;EACE,yBAAA;AA6XJ;;AAxXE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AA2XJ;AAtXE;EACE,UAAA;AAwXJ;AArXE;EACE,eAAA;AAuXJ;;AAnXA;EACE,gBAAA;AAsXF;AApXE;EAHF;IAII,iBAAA;EAuXF;AACF;;AAnXE;EACE,cAAA;AAsXJ;AApXI;EACE,cAAA;AAsXN;AAlXE;EACE,gBAAA;AAoXJ;AApWI;EAbF;IAcI,UAAA;IACA,WAAA;EAuWJ;AACF;AArWI;EAlBF;IAmBI,WAAA;EAwWJ;AACF;;AApWA;EACE;IACE,YAAA;IACA,eAAA;EAuWF;AACF;AApWA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;AAsWF;AApWE;EACE,0CAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AAsWJ;AAnWE;EACE,cAAA;AAqWJ;AAlWE;EAtBF;IAuBI,aAAA;EAqWF;AACF;;AAlWA;EACE,cAAA;AAqWF;;AAlWA;EACE,wBAAA;EACA,oBAAA;AAqWF;;AAlWA;EACE,4BAAA;EACA,mBA3OO;EA4OP,mBAAA;EACA,kBAAA;EACA,wBAAA;AAqWF;AAnWE;EACE,eAAA;AAqWJ;AAlWE;EACE,mBAAA;AAoWJ;AAjWE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAmWJ;AAjWI;EANF;IAOI,eAAA;EAoWJ;AACF;AAjWE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,oGAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAmWJ;AAhWE;EArCF;IAsCI,aAAA;EAmWF;AACF;;AAhWA;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EAEA,mBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EAGA,mCAAA;EACA,wBAAA;AAkWF;AAhWE;EACE,eAAA;EACA,wBDjSO;ECkSP,iBAAA;EACA,gBAAA;AAkWJ;AA/VE;EACE,kBAAA;AAiWJ;AA/VI;EACE,yBAAA;EACA,cA/SO;EAgTP,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EAEA,kBAAA;EACA,aAAA;AAiWN;AA7VE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;AA+VJ;AA7VI;EALF;IAMI,WAAA;EAgWJ;AACF;AA7VE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AA+VJ;AA7VI;EARF;IASI,WAAA;IACA,kBAAA;EAgWJ;AACF;AA9VI;EACE,eAAA;EACA,cAAA;AAgWN;AA7VI;EACE,eAAA;AA+VN;AAzVQ;EADF;IAKI,aAAA;IACA,cAAA;EA4VR;AACF;AA1VQ;EATF;IAUI,mBAAA;IACA,kBAAA;EA6VR;AACF;AA1VM;EACE,eAAA;AA4VR;AAzVM;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA2VR;AAxVM;EACE,kBAAA;AA0VR;AAxVQ;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA0VV;AAvVQ;EACE,cAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;AAyVV;AAtVQ;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAwVV;AAhVE;EA5IF;IA6II,kBAAA;EAmVF;AACF;;AAhVA;EACE,gBAAA;AAmVF;;AA/UE;EACE,oBAAA;EACA,mBAAA;AAkVJ;AA/UI;EALF;IAMI,YAAA;EAkVJ;AACF;AAhVI;EATF;IAUI,YAAA;EAmVJ;AACF;AAjVI;EAbF;IAcI,aAAA;EAoVJ;AACF;AAlVI;EAjBF;IAkBI,aAAA;IACA,oBAAA;EAqVJ;AACF;AAnVI;EAtBF;IAuBI,aAAA;IACA,oBAAA;EAsVJ;AACF;AApVI;EA3BF;IA4BI,WAAA;EAuVJ;AACF;AArVI;EACE,eAAA;EACA,cA3cO;EA4cP,gBAAA;AAuVN;AArVM;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAuVR;AApVM;EACE,+BAAA;AAsVR;AAnVM;EAfF;IAgBI,WAAA;EAsVN;AACF;AAlVM;EADF;IAEI,eAAA;EAqVN;AACF;AAnVM;EALF;IAMI,UAAA;EAsVN;AACF;AApVM;EATF;IAUI,WAAA;EAuVN;AACF;;AAlVA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,uBAAA;EACA,SAAA;AAqVF;;AA5UA;EACE,cAAA;EACA,sBAAA;EACA,+BAAA;AA+UF;AA7UE;EACE,cAAA;EACA,eAAA;AA+UJ;AA5UE;EACE,wBDngBO;ACi1BX;;AAzUE;EACE,eAAA;AA4UJ;AAxUI;EACE,wBDjhBK;ECkhBL,eAAA;AA0UN;AAxUI;EACE,wBDrhBK;ECshBL,eAAA;AA0UN;AAvUI;EACE,wBDvhBK;ECwhBL,cD1fe;ACm0BrB;AArUI;EACE,eAAA;EACA,wBD9hBK;EC+hBL,cDjgBe;ACw0BrB;;AAlUA;EACE,SAAA;AAqUF;;AAlUA;EACE,iBAAA;AAqUF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n$dark-black: #000000;\n$eff-bg: #6D6E70;  //full-fill message background\n\n.btn-primary.btn-outline {\n  color: #fff;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.products-grid {\n  overflow: hidden;\n}\n\n.products-grid {\n  .product-imitation {\n    padding: 10px;\n\n    img {\n      width: 100%;\n      height: auto;\n      max-height: 340px;\n      min-height: 340px;\n      -webkit-object-fit: contain;\n      -ms-object-fit: contain;\n      -moz-object-fit: contain;\n      object-fit: contain;\n    }\n  }\n\n  // .product-box {\n  //   height: 482px;\n  // }\n}\n\n.category-title {\n  font-size: 32px;\n  font-family: $muso-700 !important;\n  color: $color-neutral-dark !important;\n  margin: 0 0 20px;\n}\n\n::ng-deep.products-grid {\n  .product-box {\n    height: 482px;\n    min-height: 482px;\n    padding-bottom: 12px;\n\n    @media #{$mobile} {\n      height: auto;\n    }\n  }\n\n  .product-desc {\n    min-height: 125px;\n    padding: 10px;\n\n    .text-righ {\n      // position: absolute;\n      bottom: 0;\n      // width: 100%;\n      left: 0;\n      padding-left: 15px;\n      padding-right: 0px;\n      float: right;\n    }\n  }\n}\n\n.cart-icons {\n  float: right;\n  text-align: right;\n  top: 37px;\n  right: 30px;\n\n  .dropdown-back {\n    width: 22px;\n    display: inline-block;\n    position: relative;\n    color: #636363;\n  }\n\n  .basket-item-count {\n    position: absolute;\n    left: 0;\n    top: -12px;\n    right: 0;\n  }\n}\n\n.order-dropdown {\n  width: 80%;\n  display: inline-block;\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    width: 100%;\n    display: inline-block;\n    margin-right: 1em;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .fullwidth-mob {\n    width: 100%;\n  }\n}\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  i {\n    font-size: 8em !important;\n  }\n}\n\n.bottom-prod-btn {\n  input {\n    width: 63px;\n    height: 22px;\n    border: 1px solid #676a6c;\n    padding: 4px;\n\n    @media(max-width: 1199px) {}\n  }\n\n  .pd-0 {\n    padding: 0;\n  }\n\n  .col-sm-6 {\n    padding-left: 0;\n  }\n}\n\n.product-name {\n  min-height: 48px;\n\n  @media(max-width: 767px) {\n    min-height: unset;\n  }\n}\n\n.product-top {\n  .row {\n    margin: 0 -6px;\n\n    &>div {\n      padding: 0 6px;\n    }\n  }\n\n  &+div {\n    margin-top: 10px;\n  }\n\n  .col-md-4 {\n    @media(max-width: 1350px) {\n      // width: 33.33%;\n    }\n\n    @media(max-width: 1199px) {\n      // width: 50%;\n    }\n\n    @media(max-width: 800px) {\n      // width: 100%;\n    }\n\n    @media(max-width: 767px) {\n      width: 50%;\n      float: left;\n    }\n\n    @media(max-width: 640px) {\n      width: 100%;\n    }\n  }\n}\n\n@media (min-width: 576px) and (max-width:767px) {\n  .container {\n    width: 540px;\n    max-width: 100%;\n  }\n}\n\nnav.woocommerce-breadcrumb {\n  position: relative;\n  padding: 8px 0;\n  font-family: 'Museo-300';\n  margin-top: 22px;\n\n  &::before {\n    background: #f5f5f5 none repeat scroll 0 0;\n    content: \"\";\n    height: 100%;\n    left: -270%;\n    position: absolute;\n    top: 0;\n    width: 600%;\n    z-index: -9;\n    display: block;\n  }\n\n  a {\n    color: #767676;\n  }\n\n  @media screen and (max-width: 1200px) {\n    margin-top: 0;\n  } \n}\n\n.products-grid {\n  padding-top: 0;\n}\n\nh1.page-title {\n  font-family: 'Museo-700';\n  padding-bottom: 20px;\n}\n\n.efulfill-msg {\n  padding: 15px 15px 15px 45px;\n  background: $eff-bg;\n  margin-bottom: 10px;\n  position: relative;\n  font-family: 'Museo-300';\n\n  &--alert {\n    background: red;\n  }\n\n  &--bg {\n    background: #FF7F7F;\n  }\n\n  p {\n    color: #fff;\n    margin-bottom: 0;\n    font-size: 16px;\n    font-weight: bold;\n\n    @media screen and (max-width: 767px) {\n      font-size: 12px;\n    }\n  }\n\n  :before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: url('https://foursightonline.com/wp-content/uploads/2020/05/notification.png') no-repeat;\n    background-size: contain;\n    position: absolute;\n    top: 11px;\n    left: 10px;\n  }\n\n  @media screen and (max-width: 767px) {\n    padding: 15px;\n  }\n}\n\n.profile-content {\n  clear: both;\n  overflow: hidden;\n  width: 100%;\n  display: block;\n  // padding: 15px 4px 4px;\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid #ddd !important;\n  border-radius: 4px;\n  -webkit-transition: border .2s ease-in-out;\n  -o-transition: border .2s ease-in-out;\n  transition: border .2s ease-in-out;\n  font-family: 'Museo-300';\n\n  h3 {\n    font-size: 32px;\n    font-family: $muso-700;\n    line-height: 38px;\n    max-width: 422px;\n  }\n\n  .flagstrap {\n    position: relative;\n    \n    select {\n      background-color: #F5F5F5;\n      color: $dark-black;\n      padding: 5px;\n      width: 250px;\n      border: none;\n      font-size: 20px;\n      -webkit-appearance: button;\n      appearance: button;\n      outline: none;\n    }\n  }\n\n  .assessment-image {\n    float: left;\n    padding-left: 10px;\n    width: 24%;\n\n    @media screen and (max-width: 767px) {\n      width: 100%;\n    }\n  }\n\n  .caption.profile-text-content {\n    float: left;\n    width: 76%;\n    padding: 9px;\n    color: #333;\n    padding-top: 0 !important;\n    padding-left: 24px;\n\n    @media screen and (max-width: 767px) {\n      width: 100%;\n      padding-left: 10px;\n    }\n\n    strong {\n      font-size: 24px;\n      color: #636363;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    .profile-text {\n\n      .col-md-6 {\n        @media (min-width: 768px) {\n          -webkit-box-flex: 0;\n          -webkit-flex: 0 0 50%;\n          -ms-flex: 0 0 50%;\n          flex: 0 0 50%;\n          max-width: 50%;\n        }\n\n        @media (min-width: 1200px) {\n          padding-right: 15px;\n          padding-left: 15px;\n        }\n      }\n\n      .btn {\n        font-size: 14px;\n      }\n\n      .btn-product {\n        color: #fff;\n        background-color: #7BBC43;\n        border-color: #7BBC43;\n      }\n\n      .form-horizontal.language .form-group {\n        margin: 0 0 20px 0;\n\n        label {\n          display: inline-block;\n          max-width: 100%;\n          margin-bottom: 5px;\n          font-weight: 700;\n          font-size: 14px;\n        }\n\n        #flagstrap3 {\n          width: inherit;\n          margin: 0;\n          display: inline-block;\n          position: relative;\n        }\n\n        select {\n          color: #333;\n          background-color: #fff;\n          width: 200px;\n          display: inline-block;\n          padding: 6px 12px;\n          margin-bottom: 0;\n          font-weight: 400;\n          line-height: 1.42857143;\n          text-align: left;\n          white-space: nowrap;\n          vertical-align: middle;\n          background-image: none;\n          border: 1px solid #ccc;\n          border-radius: 4px;\n          height: 31px;\n          position: relative;\n          font-size: 12px;\n        }\n      }\n\n      \n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    text-align: center;\n  }\n}\n\n.wrapper-top {\n  margin-top: 50px;\n}\n\n.wrapper-content {\n  .cont {\n    padding-inline: 15px;\n    margin-inline: auto;\n    \n\n    @media screen and (min-width: 768px) {\n      width: 750px;\n    }\n\n    @media screen and (min-width: 992px) {\n      width: 970px;\n    }    \n\n    @media screen and (min-width: 1400px) {\n      width: 1350px;\n    }\n\n    @media screen and (min-width: 1600px) {\n      width: 1570px;\n      padding-inline: 20px;\n    }\n\n    @media screen and (max-width: 1850px) {\n      width: 1300px;\n      padding-inline: 15px;\n    }\n\n    @media screen and (max-width: 1440px) {\n      width: 100%;\n    }\n\n    .profile-text {\n      font-size: 17px;\n      color: $dark-black;\n      line-height: 1.6;\n\n      .grp-ordr {\n        text-transform: uppercase;\n        font-size: 12px;\n        padding: 10px 30px;\n      }\n\n      &--bdr {\n        border-right: 2px solid #F5F5F5;\n      }\n      \n      @media screen and (max-width: 991px) {\n        width: 100%;\n      }\n    }\n\n    .prdct {\n      @media screen and (max-width: 1199px) {\n        width: 33.3333%;\n      }\n\n      @media screen and (max-width: 991px) {\n        width: 50%;\n      }\n\n      @media screen and (max-width: 767px) {\n        width: 100%;\n      }\n    }\n  }\n}\n\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n  box-sizing: content-box;\n  height: 0;\n}\n\n// @media screen and (max-width: 1200px) {\n//   .wrapper-top {\n//     margin-top: 100px;\n//   }\n// }\n\n.api-err {\n  color: #676a6c;\n  background-color: #fff;\n  box-shadow: 0px 0px 6px #cccaca;\n\n  p {\n    color: #676a6c;\n    font-size: 14px;\n  }\n  \n  h1 {\n    font-family: $muso-700;\n  }\n}\n\n::ng-deep.prod{\n  &-hdr {\n    font-size: 32px;\n  }\n  &-body{\n\n    span {\n      font-family: $muso-300;\n      font-size: 12px;\n    }\n    input {\n      font-family: $muso-300;\n      font-size: 12px;\n    }\n\n    .muso-700 {\n      font-family: $muso-700;\n      color: $body-content-color;\n    }\n  }\n  &-list {\n    li {\n      font-size: 16px;\n      font-family: $muso-700;\n      color: $body-content-color;\n    }\n  }\n}\n\n.gap-10 {\n  gap: 10px;\n}\n\n::ng-deep.hero-prod-buy {\n  margin-top: -20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
